import { BOARD_SIZE_CHANGE } from './constants'

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [BOARD_SIZE_CHANGE]: (state, action) => ({ ...state, boardSize: { ...state.boardSize, width: action.width, height: action.height } })
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  boardSize: {
    width: 0,
    height: 0
  },
  boardPaddingLeftRight: 20,
  boardPaddingTopBottom: 20,
  idealSnapDistance: 44,
  minSnapDotsX: 12,
  minSnapDotsY: 12,
  maxSnapDotsX: 37,
  maxSnapDotsY: 37
}
export default function aboutAgeReducer (state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]

  return handler ? handler(state, action) : state
}



/** WEBPACK FOOTER **
 ** ./src/containers/GridBackground/modules/reducer.js
 **/